/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  bookinglist: 'bookinglist',
  bookingnumber: 'bookingnumber',
  bookingstate: 'bookingstate',
  bookingdate: 'bookingdate',
  travelstart: 'travelstart',
  agent: 'agent',
  leadTravelName: 'leadTravelName',
  mainservice: 'mainservice',
  amount: 'amount',
  warningMessage: 'warningMessage',
  PENDING: 'PENDING',
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
  REQUEST: 'REQUEST',
  OPTION: 'OPTION',
  QUOTE: 'QUOTE'
}; export default Keys;